import { CartAddEvent } from '@theme/events';

/* Native forms remain usable when modules or fetch are unavailable. */
function enhanceForm(form) {
  if (form.dataset.g359CartReady || !window.fetch || !window.FormData) return;
  form.dataset.g359CartReady = 'true';
  form.addEventListener('submit', async (event) => {
    if (event.defaultPrevented) return;
    if (event.submitter?.name && event.submitter.name !== 'add') return;
    event.preventDefault();
    if (form.dataset.g359CartBusy === 'true') return;
    if (!form.reportValidity()) return;
    const data = new FormData(form);
    if (!data.get('id')) return;
    const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
    if (buttons.some((button) => button.disabled)) return;
    const labels = buttons.map((button) => button.querySelector('[data-g359-main-add-label]') || button);
    const initialLabels = labels.map((label) => ({ text: label.textContent, html: label.innerHTML }));
    const message = form.querySelector('[data-g359-cart-message]');
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = root + 'cart';
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((component) => component.dataset.sectionId).filter(Boolean);
    const sections = Array.from(new Set(sectionIds)).slice(0, 5);
    if (sections.length) {
      data.set('sections', sections.join(','));
      data.set('sections_url', window.location.pathname);
    }
    const showMessage = (text, isError) => {
      if (!message) return;
      message.hidden = false;
      message.classList.toggle('is-error', Boolean(isError));
      message.textContent = text + ' ';
      const link = document.createElement('a');
      link.href = cartUrl;
      link.textContent = 'View bag';
      message.appendChild(link);
    };
    form.dataset.g359CartBusy = 'true';
    form.setAttribute('aria-busy', 'true');
    if (message) message.hidden = true;
    buttons.forEach((button, index) => { button.disabled = true; labels[index].textContent = 'Adding…'; });
    form.dispatchEvent(new Event('g359:cart-state'));
    let added = false;
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) {
        showMessage(result.description || result.message || 'This option could not be added. Please check availability.', true);
        return;
      }
      added = true;
      const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart confirmation unavailable');
      const cart = await cartResponse.json();
      const drawer = document.querySelector('cart-drawer-component');
      const drawerReady = drawer && typeof drawer.open === 'function';
      const hasRenderedSections = sections.length && sections.every((id) => result.sections?.[id]);
      if (!drawerReady || !hasRenderedSections) {
        window.location.assign(cartUrl);
        return;
      }
      form.dispatchEvent(new CartAddEvent(cart, String(data.get('id')), {
        source: 'g359-form', productId: form.closest('[data-g359-product]')?.dataset.productId,
        itemCount: cart.item_count, sections: result.sections
      }));
      showMessage('Added to your bag.', false);
      // The theme handles section updates and focus management; respect its drawer.
      document.querySelector('cart-drawer-component')?.open();
    } catch (error) {
      if (added) {
        // The POST succeeded. Never repeat it when a later refresh fails.
        window.location.assign(cartUrl);
      } else {
        showMessage('We couldn’t confirm the update. Check your bag before trying again.', true);
      }
    } finally {
      delete form.dataset.g359CartBusy;
      form.removeAttribute('aria-busy');
      buttons.forEach((button, index) => {
        button.disabled = false;
        if (labels[index] === button) labels[index].innerHTML = initialLabels[index].html;
        else labels[index].textContent = initialLabels[index].text;
      });
      form.dispatchEvent(new Event('g359:cart-state'));
    }
  });
}

function boot(scope) {
  scope.querySelectorAll('.g359-product-form, [data-g359-quick-form]').forEach(enhanceForm);
}
boot(document);
document.addEventListener('shopify:section:load', (event) => boot(event.target));
